import { render, staticRenderFns } from "./dialA36.vue?vue&type=template&id=d2e5e978&"
import script from "./dialA36.vue?vue&type=script&lang=js&"
export * from "./dialA36.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dialA36.vue"
export default component.exports